export const HISTORY_MAX = 15
export const HISTORY_KEY = 'searchGameHistory'

function normalizeSearchHistory(value, max = HISTORY_MAX) {
  if (!Array.isArray(value)) return []
  const seen = new Set()
  const list = []
  for (const item of value) {
    const text = String(item == null ? '' : item).trim()
    if (!text || seen.has(text)) continue
    seen.add(text)
    list.push(text)
    if (list.length >= max) break
  }
  return list
}

export function parseSearchHistoryValue(rawValue, max = HISTORY_MAX) {
  if (!rawValue) return []
  try {
    return normalizeSearchHistory(JSON.parse(rawValue), max)
  } catch (e) {
    return []
  }
}

export function nextSearchHistory(current, term, max = HISTORY_MAX) {
  const text = String(term == null ? '' : term).trim()
  if (!text) return normalizeSearchHistory(current, max)
  return normalizeSearchHistory([text, ...normalizeSearchHistory(current, max)], max)
}

export function safeReadSearchHistory(storage, max = HISTORY_MAX) {
  if (!storage || typeof storage.getItem !== 'function') return []
  try {
    return parseSearchHistoryValue(storage.getItem(HISTORY_KEY), max)
  } catch (e) {
    return []
  }
}

export function safeSaveSearchHistory(storage, list, max = HISTORY_MAX) {
  if (!storage || typeof storage.setItem !== 'function') return false
  try {
    storage.setItem(HISTORY_KEY, JSON.stringify(normalizeSearchHistory(list, max)))
    return true
  } catch (e) {
    return false
  }
}
